<template>
    <heads>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-1/2">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Fees Type</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Topic Added!</span>
                    <exception />
                </form>
            </div>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'

    export default {
        components: {
            Heads,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable
        },
        props:['feestype'],
        data(){
            return{
                form: useForm({
                    '_method':'PUT',
                    title: this.feestype.title,
                    status: this.feestype.status,
                }),
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('heads.feestype.update',this.feestype.id),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            }
        }
    }
</script>
